import React, { useEffect, useState } from 'react';
import { Card, CardBody, CardTitle, Col, Row } from 'reactstrap';
import { useBarcode } from '@createnextapp/react-barcode';

const base = '0000000000';

export default function PunchId({ store }) {

  const { inputRef } = useBarcode({
    value: store?.profile?.punchId !== undefined && store?.profile?.punchId?.length > 0 ? store?.profile?.punchId : base
  });

  return (
    <Card className='mb-50'>
      <CardBody>
        <CardTitle>Your Punch ID</CardTitle>
        <Row className={'text-center'}>
          <Col md="12">
            {inputRef ? <canvas id="mybarcode" ref={inputRef} /> : <p>No Barcode available</p>}
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
}
